import { ApiClient } from '@busbook/ui';

export const api = new ApiClient({
  baseUrl: '/api/v1',
  storageKey: 'busbook.platform.tokens',
  refreshPath: '/platform/auth/refresh',
  onAuthLost: () => window.dispatchEvent(new CustomEvent('busbook:auth-lost')),
});

export interface PlatformUser {
  id: string;
  email: string;
  name: string;
  phone: string | null;
  /** Null means no picture; the interface falls back to initials. */
  avatarUrl: string | null;
  role: 'PLATFORM_ADMIN';
}
